import { render, staticRenderFns } from "./ChangePwdForm.vue?vue&type=template&id=638808ab&"
import script from "./ChangePwdForm.vue?vue&type=script&lang=js&"
export * from "./ChangePwdForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports